// extracted by mini-css-extract-plugin
export default {"titleBox":"AdminsAndAgentsPage_titleBox__W1dhB"};